import { Marketplace, Paginator } from 'interfaces/marketplace';

import apiService, { ApiService } from '../api';
import { IFilter } from './types';

type MarketplaceList = {
  data: Marketplace[];
  paginator: Paginator;
};

export class MarketplaceService {
  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  public eventList(filter: IFilter): Promise<MarketplaceList> {
    return this.apiService.get('/marketplace', filter).toPromise();
  }
}

export const marketplaceService = new MarketplaceService(apiService);
